module.exports = __webpack_public_path__ + "media/images/lb/350-32f908dbcd7c80b68fe4c66d574eb481.svg";